module.exports = __webpack_public_path__ + "static/media/espci.b3048940.png";